import { useSuspenseMaxTagsQuery } from '#api/tags.queries.ts';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { PageCloser } from '#components/patterns/page-closer/PageCloser.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { fromArray, Titled } from '#util/title.ts';
import { TagReorderList } from './list/TagReorderList.tsx';
import styles from './TagReorderPage.module.css';

export function TagReorderPage() {
  const {
    data: { data: tags },
  } = useSuspenseMaxTagsQuery();

  return (
    <Titled title={(title) => fromArray(['Reorder', title])}>
      <div id="main-layout" className={styles.TagReorderPage}>
        <PageHeader
          title={
            <>
              <Link to="/tags" className="a">
                Tags
              </Link>
              {' / Reorder '}
            </>
          }
        >
          <PageCloser fallbackTo="/tags" />
        </PageHeader>
        <Banner variant="info" className="mb-40">
          Reorder tags to decide which configuration values apply first. The tag with the highest order gets top
          priority.
        </Banner>
        <TagReorderList tags={tags} />
      </div>
    </Titled>
  );
}
